import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: (props) => ({
    color: props.color === "white" ? "#fff" : "#424242",
    "& > *,& > ul > li > *": {
      textAlign: "justify",
      textJustify: "inter-word",
      fontSize: 14,
      fontFamily: "Times New Roman, Times, serif",
    },
    "& > strong": {
      display: "inline-block",
    },
  }),
});

export const TermsOfUseCmp = ({ color = "black" }) => {
  const classes = useStyles({ color });

  return (
    <div className={classes.root}>
      <div style={{ textAlign: "center" }}>
        <strong>
          CONDIÇÕES GERAIS DE UTILIZAÇÃO DA SOLUÇÃO DE NEGÓCIOS PRATELEIRA
          INFINITA DA KARSTEN S.A.
        </strong>
      </div>

      <br />

      <p>
        Estas Condições Gerais de Utilização da Solução de Negócios Prateleira
        Infinita da Karsten S.A. (“Contrato” ou “Instrumento”) contém os termos
        e condições que regem o seu acesso e utilização da solução de negócio
        Prateleira Infinita (“Plataforma” ou “Prateleira Infinita”),
        disponibilizada pela Karsten S.A., inscrita no CNPJ sob nº
        82.640.558/0001-04, com sede na Rua Johann Karsten, n.º 260, bairro
        Testo Salto, CEP 89.074-700, no município de Blumenau, estado de Santa
        Catarina (“Karsten”) e constitui um contrato entre o lojista (“Empresa
        Parceira”) e a Karsten, cujas regras deverão ser incondicionalmente
        aceitas e seguidas pelas Empresas Parceiras que tenham sido previamente
        aprovadas para utilização da plataforma para atender aos seus clientes
        (“Cliente” ou “Consumidor Final”).
        <strong>
          Este instrumento, poderá ser complementado pelo Termo de Adesão do
          Usuário (“Termo de Adesão”), relativo à individualização e descrição
          de condições comerciais específicas.
        </strong>
      </p>

      <p></p>

      <strong>
        <u>1. ESCOPOS DA PARCERIA</u>
      </strong>

      <p></p>

      <p>
        1.1&ensp;&ensp;&ensp;&ensp;Criar, em conjunto, Karsten e Empresa
        Parceira, um sistema multicanal de vendas, destinado ao público em
        geral, que compreenderá o sistema tradicional (físico) já existente e um
        novo canal através de plataforma virtual, doravante denominada de
        “Prateleira Infinita”, visando maximizar as vendas tanto para a Karsten
        quanto para a Empresa Parceira.
      </p>

      <p></p>

      <p>
        1.2&ensp;&ensp;&ensp;&ensp;Proporcionar à Empresa Parceira acesso direto
        e online, de produtos objeto desta Parceria, de modo que, no momento da
        venda ao Consumidor Final, o vendedor da Empresa Parceira possa
        verificar e apresentar ao Cliente os produtos existentes nos estoques da
        Karsten (quantidades, modelos, cores, tamanhos etc.), além daqueles
        existentes no estoque físico da Empresa Parceira.
      </p>

      <p></p>

      <p>
        1.3&ensp;&ensp;&ensp;&ensp;Permitir à Empresa Parceira oferecer uma
        maior gama de produtos, sem ocupar espaço físico, eliminando rupturas de
        estoque e melhorando a interação com o Consumidor Final.
      </p>

      <p></p>

      <strong>
        <u>2. PREÂMBULO</u>
      </strong>

      <p></p>

      <p>
        2.1&ensp;&ensp;&ensp;&ensp;Estas Condições Gerais, são extensivas à
        todas as entidades afiliadas à Karsten (“Afiliadas”) e seus respectivos
        parceiros comerciais (“Parceiros”).
      </p>

      <p></p>

      <p>
        2.2&ensp;&ensp;&ensp;&ensp;A aceitação destas Condições Gerais, pelo
        Revendedor, é imprescindível para a utilização da Plataforma.
      </p>

      <p></p>

      <p>
        2.3&ensp;&ensp;&ensp;&ensp;Termos com inicial maiúscula têm os
        significados atribuídos neste Contrato.
      </p>

      <p></p>

      <p>
        2.4&ensp;&ensp;&ensp;&ensp;Em caso de conflito entre as presentes
        Condições Gerais e o Termo de Adesão, prevalecerá o disposto no Termo de
        Adesão.
      </p>

      <p></p>

      <p>
        2.5&ensp;&ensp;&ensp;&ensp;A Empresa Parceira declara haver lido e
        aceito todas as cláusulas do presente Contrato e, bem assim, dos seus
        Anexos abaixo destacados, obrigando-se, por si, seus sócios ou
        acionistas, dirigentes, funcionários e prepostos, a integral e fielmente
        cumpri-las, sob pena de responder pelas perdas e danos causados à
        Karsten e/ou a terceiros.
      </p>

      <p></p>

      <p>
        2.6&ensp;&ensp;&ensp;&ensp;A Karsten poderá, a qualquer tempo, mediante
        prévia comunicação a Empresa Parceira, alterar as presentes Condições
        Gerais e/ou seus Anexos. Caso a Empresa Parceira não concorde com as
        alterações, poderá encerrar a sua participação na Plataforma
        imediatamente, o que se dará sem multa ou indenização de qualquer tipo,
        de lado a lado. Todavia, a permanência da Empresa Parceira na Plataforma
        após as alterações comunicadas pela Karsten, importará na sua
        concordância em relação às mesmas.
      </p>

      <p></p>

      <strong>
        <u>3. ANEXOS</u>
      </strong>

      <p></p>

      <p>3.1.&ensp;&ensp;&ensp;&ensp;Integra as presentes Condições Gerais:</p>

      <p></p>

      <ul>
        <li>
          <p style={{ textAlign: "start" }}>
            Política de Privacidade da Karsten, disponível para download no
            endereço:{" "}
            <a href="https://www.karsten.com.br/Institucional/Ajuda/politica-privacidade">
              https://www.karsten.com.br/Institucional/Ajuda/politica-privacidade
            </a>
          </p>
        </li>
        <li>
          <p style={{ textAlign: "start" }}>
            Política de Privacidade da Trussardi, disponível para download no
            endereço:{" "}
            <a href="https://www.trussardi.com.br/institucional/ajuda/politica-de-privacidade">
              https://www.trussardi.com.br/institucional/ajuda/politica-de-privacidade
            </a>
          </p>
        </li>
      </ul>

      <p></p>

      <strong>
        <u>4. OBJETO DO CONTRATO</u>
      </strong>

      <p></p>

      <p>
        4.1&ensp;&ensp;&ensp;&ensp;O presente Contrato tem como objeto
        regulamentar a participação da Empresa Parceria na Plataforma da
        Karsten, através de um sistema multicanal de vendas, incluindo o sistema
        tradicional (físico) já existente entre ambas e um novo canal virtual
        (“Prateleira Infinita”), para complementar o portfólio de produtos
        existentes nos estoques físicos da Empresa Parceira.
      </p>

      <p></p>

      <p>
        4.2&ensp;&ensp;&ensp;&ensp;Inicialmente, a Prateleira Infinita ficará
        restrita aos produtos com a marca “Karsten” e “Trussardi”, de
        propriedade da Karsten, podendo futuramente vir a ser estendida para
        outras linhas e marcas.
      </p>

      <p></p>

      <strong>
        <u>5. ELEGIBILIDADE</u>
      </strong>

      <p></p>

      <p>
        5.1&ensp;&ensp;&ensp;&ensp;Somente as pessoas jurídicas regularmente
        constituídas e legalmente representadas, estarão aptas a utilizar a
        Plataforma da Karsten, condicionada a sua participação ao preenchimento
        do Termo de Adesão e prévia aprovação de seu cadastro.
      </p>

      <p></p>

      <strong>
        <u>6. CADASTRO DA EMPRESA PARCEIRA</u>
      </strong>

      <p></p>

      <p>
        6.1&ensp;&ensp;&ensp;&ensp;Ao se cadastrar na plataforma, a Empresa
        Parceira declara e garante que:
      </p>

      <p></p>

      <ul>
        <li>
          <p>
            (a)&ensp;&ensp;&ensp;&ensp;é uma empresa legalmente constituída e
            existente sob as leis da República Federativa do Brasil, possuindo,
            válidas, todas as autorizações necessárias para conduzir e explorar
            as suas atividades, sem impedimentos de qualquer ordem;
          </p>
        </li>
      </ul>
      <p></p>

      <ul start="2">
        <li>
          <p>
            (b)&ensp;&ensp;&ensp;&ensp;não utiliza e não admite que seus
            fornecedores e parceiros comerciais utilizem mão de obra em
            desacordo com a legislação, incluindo trabalho infantil, escravo e
            análogo ao escravo;
          </p>
        </li>
      </ul>
      <p></p>

      <ul start="3">
        <li>
          <p>
            (c)&ensp;&ensp;&ensp;&ensp;está ciente que a sua participação na
            Plataforma está condicionada aos termos e condições do presente
            Instrumento; e,
          </p>
        </li>
      </ul>
      <p></p>

      <ul start="4">
        <li>
          <p>
            (d)&ensp;&ensp;&ensp;&ensp;está ciente que a Karsten em hipótese
            alguma se comprometerá com o resultado de vendas e a performance da
            Empresa Parceira, tampouco se comprometendo com o vulume de
            faturamento ou quantidade de transações realizadas na Plataforma,
            pelo o que a Empresa Parceira declara estar plenamente ciente e
            concorde quanto ao fato de que nenhuma indenização pela frustração
            de suas expectativas financeiras em relação à comercialização dos
            seus serviços ou produtos na Plataforma caberá à Karsten, ainda que
            sob a forma de lucros cessantes ou gastos com investimentos
            logísticos e tecnológicos relacionados à sua utilização da
            Plataforma, dentre quaisquer outros custos.
          </p>
        </li>
      </ul>
      <p></p>

      <p>
        6.2&ensp;&ensp;&ensp;&ensp;Todos os dados e documentos solicitados pela
        Karsten e fornecidos pela Empresa Parceira no ato do preenchimento do
        Termo de Adesão, serão tidos pela Karsten como verdadeiros e válidos,
        responsabilizando-se, a Empresa Parceira, civil e criminalmente, pela
        sua inveracidade ou inexatidão, obrigando-se a mantê-los válidos e
        atualizados durante todo o tempo em que perdurar o seu relacionamento
        comercial com a Karsten.
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;6.2.1.&ensp;&ensp;&ensp;&ensp;Em hipótese alguma
        a Karsten, suas afiliadas e/ou parceiros, serão responsabilizados pela
        inveracidade, inexatidão ou falta de atualização dos dados e documentos
        fornecidos pela Empresa Parceira.
      </p>

      <p></p>

      <p>
        6.3&ensp;&ensp;&ensp;&ensp;A Empresa Parceira deverá imediatamente
        comunicar a Karsten na ocorrência de falência, recuperação judicial,
        intervenção, liquidação judicial ou extrajudicial.
      </p>

      <p></p>

      <p>
        6.4&ensp;&ensp;&ensp;&ensp;A Empresa Parceira reconhece e concorda que,
        durante o processo de validação e/ou revalidação periódica de seu
        cadastro, a Karsten, poderá, a qualquer tempo, solicitar-lhe informações
        ou documentos adicionais, realizar pesquisas junto aos Órgãos de
        Proteção ao Crédito e de Defesa do Consumidor e junto aos Órgãos da
        Administração Pública e do Poder Judiciário, no sentido de aferir a
        idoneidade financeira da Empresa Parceira e o seu comprometimento em
        relação ao cumprimento das normas de proteção ao consumidor, sendo causa
        para o seu imediato descredenciamento da Plataforma, a exclusivo
        critério da Karsten, a existência de apontamentos que considere
        desabonadores, hipótese em que a Empresa Parceira não fará jus a
        quaisquer perdas e danos.
      </p>

      <p></p>

      <p>
        6.5&ensp;&ensp;&ensp;&ensp;Ao preencher o Termo de Adesão e fornecer as
        informações e documentos, a Empresa Parceira expressamente permite a
        coleta, o armazenamento e o compartilhamento de tais dados pela Karsten
        junto às suas afiliadas, durante o período do prazo contratual.
      </p>

      <p></p>

      <strong>
        <u>7. DIRETRIZES OPERACIONAIS</u>
      </strong>

      <p></p>

      <p>
        7.1&ensp;&ensp;&ensp;&ensp;Após ter o seu cadastro previamente aprovado,
        a Karsten disponibilizará à Empresa Parceira acesso online e em tempo
        real aos estoques de produtos, objeto da parceria, existentes em seus
        Centros de Distribuição.
      </p>

      <p></p>

      <p>
        7.2&ensp;&ensp;&ensp;&ensp;A Empresa Parceira terá acesso a informações
        básicas de seu interesse, como, por exemplo, produtos disponíveis para
        venda, pedidos realizados e cadastro de seus clientes, devendo fazer o
        gerenciamento das informações.
      </p>

      <p></p>

      <p>
        7.3&ensp;&ensp;&ensp;&ensp;O acesso à Prateleira Infinita se dará
        mediante login e senha de uso pessoal, individual e intransferível,
        previamente cadastrados, por meio de dispositivo móvel ou
        microcomputador conectado à internet, comprometendo-se a não divulgar,
        em hipótese alguma, tais dados a terceiros, responsabilizando-se
        integral e exclusivamente pelo uso indevido de tais dados.
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;7.3.1&ensp;&ensp;&ensp;&ensp;A Empresa Parceira
        compromete-se a notificar imediatamente a Karsten, a respeito de
        qualquer uso não autorizado da sua conta, login e senha.
      </p>

      <p></p>

      <p>
        7.4&ensp;&ensp;&ensp;&ensp;As atividades de logística relacionadas a
        entregas, trocas, devoluções etc., referentes às vendas efetuadas por
        meio da Prateleira Infinita ficarão sob responsabilidade da Karsten.
      </p>

      <p></p>

      <p>
        7.5&ensp;&ensp;&ensp;&ensp;As vendas efetuadas por meio da Prateleira
        Infinita serão faturadas no estabelecimento da Karsten para o Consumidor
        Final, através de Nota Fiscal Eletrônica (“NF-e”), que será remetida
        juntamente com a mercadoria ao Consumidor Final, sendo que em casos
        específicos, a Empresa Parceira autoriza que a Karsten informe nos dados
        adicionais na NF-e o endereço de sua sede.
      </p>

      <p></p>

      <strong>
        <u>8. REMUNERAÇÃO</u>
      </strong>

      <p></p>

      <p>
        8.1&ensp;&ensp;&ensp;&ensp;Em remuneração pelas vendas efetuadas por
        meio da Prateleira Infinita, a Empresa Parceira pagará para a Karsten o
        percentual de 18% (dezoito por cento) sobre o valor de <i>sell-in</i>{" "}
        dos produtos que foram vendidos via Plataforma, que será pago juntamente
        com o valor das mercadorias adquiridas através da Prateleira Infinita,
        até o dia 15 (quinze) do mês subsequente ao da operação de compra e
        venda.
      </p>

      <p></p>

      <strong>
        &ensp;&ensp;&ensp;&ensp;8.1.1.&ensp;&ensp;&ensp;&ensp;O pagamento da
        remuneração será devido pela Empresa Parceira à Karsten, mesmo nas
        hipóteses (i) em caso de insucesso na entrega e/ou (ii) em se
        verificando, por qualquer motivo, o cancelamento do pedido após o seu
        processamento e pagamento, exceto na hipótese de o consumidor exercer o
        direito de arrependimento previsto no artigo 49, caput, do Código de
        Defesa do Consumidor.
      </strong>

      <p></p>

      <p>
        8.2&ensp;&ensp;&ensp;&ensp;A política de preços da Prateleira Infinita
        será a mesma utilizada pela Karsten para seu canal direto Karsten (
        <a href="http://www.karsten.com.br">www.karsten.com.br</a>). As
        diretrizes de descontos serão deliberadas via cupom de desconto
        pré-definidos pelas partes.
      </p>

      <p></p>

      <p>
        8.3&ensp;&ensp;&ensp;&ensp;Os pagamentos pelos clientes poderão ser
        efetuados de diversas formas a serem definidas de comum acordo pelas
        partes, inclusive podendo estabelecer pagamento com dois cartões, número
        de parcelas e valor mínimo de cada parcela (de crédito ou débito).
      </p>

      <p></p>

      <p>
        8.4&ensp;&ensp;&ensp;&ensp;O atraso ou a injustificada inadimplência
        quanto ao pagamento das mercadorias e ao percentual previsto na cláusula
        8.1, sujeitará a Empresa Parceira, além do bloqueio da Plataforma, ao
        pagamento do total do principal, acrescido de juros de mora de 1% (um
        por cento) ao mês e atualização monetária pelo índice IGPM/FGV, ambos
        calculados desde a data do inadimplemento até o efetivo cumprimento da
        obrigação, acrescendo-se ao montante multa de natureza não compensatória
        ora estabelecida em 10% (dez por cento) sobre o débito atualizado.
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;8.4.1.&ensp;&ensp;&ensp;&ensp;Todo o custo que a
        Karsten tiver com a cobrança judicial ou extrajudicial de valores
        devidos pela Empresa Parceira que não tenham sido quitados no tempo e
        modo ajustados, serão a este repassados, inclusive honorários
        advocatícios fixados, sobre o montante atualizado da dívida, em 10% (dez
        por cento) para a cobrança extrajudicial e 20% (vinte por cento) para a
        cobrança judicial.
      </p>

      <p></p>

      <strong>
        <u>9. PLATAFORMA E PROPRIEDADE INTELECTUAL</u>
      </strong>

      <p></p>

      <p>
        9.1&ensp;&ensp;&ensp;&ensp;A Plataforma será disponibilizada pela
        Karsten no estado em que se encontra, sendo certo que, inobstante todos
        os esforços enviados pela primeira no sentido de disponibilizar uma
        plataforma de alta performance e segura, não há garantias de que
        funcione ininterruptamente, que seja livre problemas técnicos ou
        operacionais e de ataques cibernéticos.
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;9.1.1.&ensp;&ensp;&ensp;&ensp;A Karsten em
        hipótese alguma se responsabilizará por quaisquer danos ou prejuízos
        decorrentes da indisponibilidade total ou parcial da Plataforma, desde
        que não seja comprovada sua culpa exclusiva, em decorrência de:
      </p>

      <p></p>

      <p>&ensp;&ensp;&ensp;&ensp;(a) manutenção técnica e/ou operacional;</p>

      <p></p>

      <p>&ensp;&ensp;&ensp;&ensp;(b) indisponibilidade de acesso ao Site;</p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(c) interrupção ou suspensão dos serviços
        fornecidos por empresas que disponibilizam acesso à internet;
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(d) caso fortuito ou eventos de força maior que
        impeçam a sua disponibilidade.
      </p>

      <p></p>

      <p>
        9.2&ensp;&ensp;&ensp;&ensp;A Karsten também não se responsabilizará
        pelas perdas e danos advindos de falhas na internet, problemas de
        conexão, atos causados por terceiros, casos fortuitos ou motivos de
        força maior.
      </p>

      <p></p>

      <p>
        9.3&ensp;&ensp;&ensp;&ensp;Por se tratar de uma Plataforma digital, a
        Karsten não se responsabiliza por qualquer dano que o equipamento da
        Empresa Parceira ou de terceiros venha a ter em decorrência da
        utilização da plataforma ou navegação na internet, não se
        responsabilizando pelos prejuízos daí advindos.
      </p>

      <p></p>

      <p>
        9.4&ensp;&ensp;&ensp;&ensp;A Empresa Parceira reconhece que, toda e
        qualquer propriedade intelectual utilizada pela Karsten, é propriedade
        ou está licenciada à esta e/ou às suas afiliadas e coligadas,
        incluindo-se (i) marcas (registradas ou não), nomes comerciais, nomes de
        domínio e outros nomes que identificam a Karsten, suas afiliadas e
        serviços; (ii) patentes, invenções patenteáveis, descobertas,
        aprimoramentos, ideias, know-how, metodologia de fórmulas, processos,
        algoritmos, tecnologias e programas de computador (incluindo código
        fonte e código objeto); (iii) segredos comerciais e informações
        confidenciais; (iv) direitos autorais, projetos, direitos de criação ou
        outros trabalhos, registros ou solicitações de registro de direitos
        autorais em qualquer jurisdição; e (v) direitos de base de dados.
      </p>

      <p></p>

      <p>
        9.5&ensp;&ensp;&ensp;&ensp;Todos os direitos de titularidade e
        propriedade intelectual relacionados à Plataforma, incluindo mas não se
        limitando, a funcionalidades, aprimoramentos, correções e atualizações,
        arquitetura e identidade visual, pertencem exclusivamente à Karsten e/ou
        aos seus respectivos fornecedores, concedendo-se a Empresa Parceira, nos
        termos do presente Instrumento, o direito de utilizar a plataforma
        enquanto o seu cadastro estiver ativo, sendo-lhe expressamente vedado
        apropriar-se de qualquer funcionalidade ou conteúdo da plataforma e/ou
        reproduzi-la total ou parcialmente, sem a prévia e expressa autorização
        da Karsten, sob pena de vir a responder pelas perdas e danos causados.
      </p>

      <p></p>

      <strong>
        &ensp;&ensp;&ensp;&ensp;9.5.1.&ensp;&ensp;&ensp;&ensp;O direito de
        utilização da Plataforma ora concedido pela Karsten a Empresa Parceira,
        não a autoriza (i) a modificá-la, copiá-la ou adaptá-las, (ii)
        sublicenciar, alugar, arrendar, emprestar, dar, ou de qualquer forma
        transferir total ou parcialmente o seu direito de uso para terceiros;
        (iii) violar a plataforma, sob qualquer motivação, em qualquer
        circunstância, ou (iv) executar qualquer ação não prevista neste
        Instrumento ou que não tenha sido expressamente autorizada pela Karsten,
        assim como, mas não se limitando, à introdução de programas de
        computador (bots/robôs) na plataforma.
      </strong>

      <p></p>

      <p>
        9.6&ensp;&ensp;&ensp;&ensp;A Karsten poderá, a qualquer tempo, e, a seu
        exclusivo critério, modificar, suspender ou desativar definitivamente a
        Plataforma, mediante aviso prévio geral a todos as Empresas Parceiras,
        sem que disto decorra o direito a qualquer ressarcimento ou indenização
        por parte destes últimos, permanecendo, todavia, válidas e eficazes
        todas as disposições previstas neste instrumento, no que efetivamente
        couber.
      </p>

      <p></p>

      <strong>
        <u>10. INEXISTÊNCIA DE VÍNCULO</u>
      </strong>

      <p></p>

      <p>
        10.1&ensp;&ensp;&ensp;&ensp;O presente Instrumento e a participação da
        Empresa Parceira na Plataforma, não geram qualquer vínculo entre as
        partes e não importam qualquer acordo operacional, <i>joint venture</i>,
        associação, fusão, cisão, incorporação ou qualquer outro vínculo de
        natureza societária, de representação, mandato, franquia ou consórcio
        entre as partes, seus sócios, afiliadas, controladas e/ou respectivos
        funcionários, sendo expressamente excluídas quaisquer presunções de
        solidariedade ou subsidiariedade, ativa ou passiva, entre as partes, no
        cumprimento de suas obrigações.
      </p>

      <p>
        10.2&ensp;&ensp;&ensp;&ensp;Este instrumento não estabelece qualquer
        vínculo empregatício ou responsabilidade por uma das partes, seja
        solidária ou subsidiária, com relação aos empregados, prepostos ou
        terceiros que a outra parte designar para o cumprimento de suas
        obrigações, correndo por conta exclusiva da respectiva parte, todas as
        despesas com esses empregados, prepostos ou terceiros, inclusive
        encargos decorrentes da legislação vigente, seja fiscal, trabalhista,
        previdenciária, securitária ou qualquer outra.
      </p>

      <p></p>

      <p>
        10.3&ensp;&ensp;&ensp;&ensp;As partes são contratantes independentes, e
        nenhuma delas poderá responder por dívidas, tributos, obrigações ou
        insucesso comercial da outra parte.
      </p>

      <p></p>

      <strong>
        <u>
          11.&ensp;&ensp;&ensp;&ensp;PAGAMENTO DE TRIBUTOS E CUMPRIMENTO DE
          OBRIGAÇÕES FISCAIS
        </u>
      </strong>

      <p></p>

      <p>
        11.1&ensp;&ensp;&ensp;&ensp;A Empresa Parceira é exclusivamente
        responsável pelo cumprimento das obrigações fiscais e tributárias
        decorrentes da comercialização dos produtos, assim como pelo cumprimento
        de qualquer outra obrigação decorrente do exercício de suas atividades,
        nos termos da legislação vigente.
      </p>

      <p></p>

      <strong>
        <u>12. PRAZO DE VIGÊNCIA E RESCISÃO</u>
      </strong>

      <p></p>

      <p>
        12.1&ensp;&ensp;&ensp;&ensp;A participação da Empresa Parceira na
        Plataforma se dará por prazo indeterminado, a partir da data de
        aprovação do cadastro pela Karsten e aceite da Empresa Parceira (“
        <i>opt in</i>”) neste Instrumento e seus Anexos, ressalvadas as
        hipóteses de suspensão ou cancelamento do seu cadastro abaixo previstas.
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;12.1.1.&ensp;&ensp;&ensp;&ensp;Independentemente
        da adoção de toda e qualquer medida contratual ou legalmente cabível à
        espécie, a qualquer tempo e sem a necessidade de prévio aviso, a Karsten
        poderá, a seu exclusivo critério e a depender da gravidade da situação,
        (i) advertir a Empresa Parceira, (ii) suspender a utilização da
        plataforma em toda e qualquer hipótese de descumprimento dos termos e
        condições previstos neste Instrumento e/ou de ilicitude de conduta por
        parte da Empresa Parceira, sem que tais fatos gerem qualquer direito de
        ressarcimento ou indenização a Empresa Parceira por parte da Karsten,
        suas afiliadas ou parceiros.
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;12.1.2.&ensp;&ensp;&ensp;&ensp;A suspensão ou
        cancelamento do cadastro da Empresa Parceira para utilização da
        Plataforma, também se dará pela negativa desta em fornecer as
        informações e documentos necessários à análise, validação e revalidação
        do seu cadastro.
      </p>

      <p></p>

      <p>
        12.2&ensp;&ensp;&ensp;&ensp;A participação da Empresa Parceira na
        Plataforma, poderá ser imotivadamente cancelada por qualquer das partes,
        sem ônus ou penalidades, mediante aviso prévio com 30 (trinta) dias de
        antecedência, hipótese em que, decorrido este prazo e procedidos aos
        acertos e retenções eventualmente previstas, o presente Instrumento
        ficará rescindido de fato e de direito, mantendo-se, todavia, as
        obrigações das partes no que se refere aos pedidos dos Clientes que
        tenham sido processados e aprovados através da plataforma.
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;12.2.1.&ensp;&ensp;&ensp;&ensp;Caso seja da
        Empresa Parceira a decisão de encerrar a sua participação na Plataforma,
        esta deverá quitar suas obrigações financeiras no prazo de 10 (dez)
        dias. Em não o fazendo, ficará a Empresa Parceira automaticamente
        constituída em mora, respondendo pelos encargos moratórios previstos
        neste Instrumento e pelos efeitos da sua inadimplência, principalmente
        protesto de título, negativação junto aos órgãos de proteção ao crédito
        e cobrança judicial ou extrajudicial.
      </p>

      <p></p>

      <p>
        12.3&ensp;&ensp;&ensp;&ensp;A suspensão ou encerramento da participação
        da Empresa Parceira na Plataforma, importará no cancelamento da captação
        de novas vendas deste na Prateleira Infinita, todavia permanecendo
        válidas e plenamente exequíveis as demais disposições deste Instrumento
        e de seus Anexos, até a plena e satisfatória liquidação de todas as
        obrigações decorrentes da comercialização de produtos da Karsten.
      </p>

      <p></p>

      <p>
        12.4&ensp;&ensp;&ensp;&ensp;A Empresa Parceira não fará, em hipótese
        alguma, jus a qualquer tipo de ressarcimento ou reparação decorrente da
        decisão injusta da Karsten em suspender ou cancelar a sua participação
        na Plataforma, por qualquer razão que seja.
      </p>

      <p></p>

      <p>
        12.5&ensp;&ensp;&ensp;&ensp;Bloqueio na plataforma por conta de
        inadimplência junto à Karsten
      </p>

      <p></p>

      <strong>
        <u>13. CONFIDENCIALIDADE</u>
      </strong>

      <p></p>

      <p>
        13.1&ensp;&ensp;&ensp;&ensp;As partes, por si, seus sócios ou
        acionistas, gestores, funcionários e/ou prepostos, obriga-se a manter o
        mais completo e absoluto sigilo sobre todas e quaisquer informações
        relacionadas a Plataforma, e, bem assim, toda e qualquer informação
        relacionada à outra parte, suas afiliadas, parceiros e aos Clientes, as
        quais venha a ter acesso em virtude da sua participação e permanência na
        plataforma (“Informações Confidenciais”).
      </p>

      <p></p>

      <p>
        13.2&ensp;&ensp;&ensp;&ensp;As partes reconhecem a importância de se
        manter as informações confidenciais em segurança e sob sigilo,
        obrigando-se a tomar todas as medidas necessárias para impedir que sejam
        transferidas, reveladas, divulgadas ou utilizadas, sem autorização da
        outra parte.
      </p>

      <p></p>

      <p>
        13.3&ensp;&ensp;&ensp;&ensp;É vedado as partes utilizar as informações
        confidenciais para quaisquer outros fins que não aqueles relacionados a
        utilização da Plataforma.
      </p>

      <p></p>

      <p>
        13.4&ensp;&ensp;&ensp;&ensp;Não são consideradas informações
        confidenciais, aquelas que (i) sejam, comprovadamente, de conhecimento
        da outra parte anteriormente à sua divulgação ou (ii) sejam ou venham a
        se tornar de domínio público, sem qualquer intervenção da outra parte.
      </p>

      <p></p>

      <strong>
        <u>
          14. TRATAMENTO DOS DADOS CADASTRAIS DOS CLIENTES E LEI GERAL DE
          PROTEÇÃO DE DADOS
        </u>
      </strong>

      <p></p>

      <p>
        14.1&ensp;&ensp;&ensp;&ensp;Durante o desenvolvimento de quaisquer
        atividades relacionadas à utilização da Plataforma para comercialização
        dos produtos da Karsten, as partes deverão cumprir todas as normas
        vigentes relativas à proteção de dados pessoais (notadamente, a Lei
        Federal 13.709/2018 - Lei Geral de Proteção de Dados), empenhando-se em
        proceder ao devido tratamento dos dados pessoais dos Clientes e dos
        prepostos da Empresa Parceira que venham a mostrar-se necessário à venda
        dos produtos na Plataforma, fazendo-o no estrito e rigoroso cumprimento
        do ordenamento jurídico.
      </p>

      <p></p>

      <p>14.2&ensp;&ensp;&ensp;&ensp;As partes obrigam-se, nomeadamente, a:</p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(a) tratar e usar os dados pessoais e cadastrais
        dos Clientes, nos termos legalmente permitidos, em especial recolhendo,
        registrando, organizando, conservando, consultando ou transmitindo os
        mesmos, apenas e somente nos casos em que o seu titular tenha dado o
        consentimento inequívoco, expresso e determinado ou nos restantes
        legalmente previstos;
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(b) tratar os dados referidos na alínea (a)
        supra, de modo compatível com as finalidades para os quais tenham sido
        recolhidos e no estrito cumprimento das atribuições previstas no
        presente Instrumento;
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(c) conservar os dados referidos na alínea (a)
        acima, apenas durante o período necessário à prossecução das finalidades
        da recolha ou do tratamento posterior, garantindo a sua
        confidencialidade;
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(d) implementar as medidas técnicas e
        administrativas necessárias para proteger os dados referidos na alínea
        (a) acima contra a destruição, acidental ou ilícita, a perda acidental,
        a alteração, a difusão ou o acesso não autorizado, bem como contra
        qualquer outra forma de tratamento ilícito dos mesmos;
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(e) informar imediatamente à outra parte, caso
        exista alguma quebra de segurança, ou suspeita da mesma,
        independentemente de colocar ou não em causa a segurança e integridade
        dos dados pessoais referidos na alínea (a) supra, devendo prestar toda a
        colaboração necessária em qualquer investigação que venha a ser
        realizada;
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(f) garantir o exercício, pelos titulares dos
        dados pessoais descritos na alínea (a) acima, dos direitos de
        informação, acesso e oposição ao armazenamento e uso dos referidos
        dados, entre outros previstos na legislação brasileira; e,
      </p>

      <p></p>

      <p>
        &ensp;&ensp;&ensp;&ensp;(g) assegurar que os seus dirigentes,
        colaboradores e/ou prestadores de serviços que venham a ter acesso aos
        dados pessoais no contexto do presente instrumento, cumpram
        integralmente todas as suas disposições e as disposições legais
        aplicáveis em matéria de proteção de dados pessoais, não cedendo ou
        divulgando tais dados pessoais e as transações financeiras dos
        consumidores do Cliente a terceiros, nem deles fazendo uso para
        quaisquer fins que não os estritamente previstos no presente instrumento
        e/ou consentidos pelos respectivos titulares.
      </p>

      <p></p>

      <p>
        14.3&ensp;&ensp;&ensp;&ensp;As partes, por si, seus sócios, acionistas,
        dirigentes, empregados ou prepostos, compromete-se a defender, isentar e
        indenizar, inclusive em regresso, a outra parte em relação à toda e
        qualquer demanda, perdas, passivos, danos, notificações e processos
        administrativos e judiciais relacionados ao descumprimento de quaisquer
        obrigações estabelecidas neste instrumento ou na legislação aplicável,
        especialmente no que diz respeito ao tratamento de dados pessoais.
      </p>

      <p></p>

      <p>
        14.4&ensp;&ensp;&ensp;&ensp;As partes concordam que, as condições
        estipuladas neste instrumento e o cumprimento da legislação aplicável ao
        tratamento de dados pessoais, são de importância extraordinária para a
        imagem, a reputação e os negócios de ambas as partes, que poderão ser
        prejudicadas de forma irreparável por qualquer violação cometida pela
        parte contrária. Assim sendo, o comprovado descumprimento de quaisquer
        dos deveres estabelecidos nesta Cláusula, acarretará a imediata rescisão
        do presente Contrato, sem prejuízo da parte infratora responder civil e
        criminalmente pelos prejuízos causados à outra parte e/ou terceiros.
      </p>

      <p></p>

      <strong>
        <u>15. PRÁTICAS ANTICORRUPÇÃO E DE PREVENÇÃO À LAVAGEM DE DINHEIRO</u>
      </strong>

      <p></p>

      <p>
        15.1&ensp;&ensp;&ensp;&ensp;As partes declaram conhecer e cumprir
        rigorosamente as normas de prevenção à corrupção previstas na legislação
        brasileira, dentre elas, a Lei Federal nº 12.846/2013 e seus
        regulamentos (em conjunto, “Leis Anticorrupção”) e a Lei Federal nº
        9.613/1998 (Lei de Prevenção à Lavagem de Dinheiro), obrigando-se a (i)
        não dar, oferecer ou prometer qualquer bem de valor ou vantagem de
        qualquer natureza a agentes públicos ou a pessoas a eles relacionadas ou
        ainda quaisquer outras pessoas, empresas e/ou entidades privadas, com o
        objetivo de obter vantagem indevida, influenciar ato ou decisão ou
        direcionar negócios ilicitamente e (ii) adotar as melhores práticas, com
        o objetivo de prevenir atos de corrupção, fraude, práticas ilícitas ou
        lavagem de dinheiro.
      </p>

      <p></p>

      <p>
        15.2&ensp;&ensp;&ensp;&ensp;As partes obrigam-se a notificar prontamente
        a outra parte, por escrito, a respeito de qualquer suspeita ou violação
        ao disposto na Leis Anticorrupção e de Prevenção à Lavagem de Dinheiro.
      </p>

      <p></p>

      <p>
        15.3&ensp;&ensp;&ensp;&ensp;A comprovada violação das obrigações
        previstas nesta cláusula, é causa para a imediata rescisão deste
        instrumento e o definitivo descredenciamento da Empresa Parceira, sem
        prejuízo da cobrança de eventuais perdas e danos causados à outra parte
        ou a terceiros.
      </p>

      <p></p>

      <strong>
        <u>16. DISPOSIÇÕES GERAIS</u>
      </strong>

      <p></p>

      <p>
        16.1&ensp;&ensp;&ensp;&ensp;A divulgação conjunta do nome ou de qualquer
        sinal de identificação das partes (logomarca, por exemplo) deverá ser
        efetuada com cautela de modo que terceiros não venham, eventualmente, a
        ser induzidos em erro acerca das responsabilidades pessoais de cada
        parte, devendo as partes, de comum acordo, autorizarem previamente
        qualquer divulgação envolvendo o nome da outra parte.
      </p>

      <p></p>

      <p>
        16.2&ensp;&ensp;&ensp;&ensp;O presente Contrato não transfere
        responsabilidades pessoais de uma parte para a outra, de modo que cada
        parte continua obrigada a cumprir as obrigações que lhe são inerentes,
        tanto as previstas na legislação vigente quanto as originadas deste
        Contrato.
      </p>

      <p></p>

      <p>
        16.3&ensp;&ensp;&ensp;&ensp;Se uma das partes vier a ser demandada,
        judicial ou extrajudicialmente, por obrigação da outra parte, deverá
        notificar a parte e esta, assim que tomar conhecimento da situação,
        obriga-se a assumir a responsabilidade. E, se uma das partes vier a ser
        condenada, administrativa ou judicialmente, a pagar valor ou cumprir
        obrigação de responsabilidade da outra parte, a parte responsável, assim
        que tomar conhecimento, deverá reembolsar imediatamente a outra parte
        e/ou cumprir a obrigação.
      </p>

      <p></p>

      <p>
        16.4&ensp;&ensp;&ensp;&ensp;O presente Instrumento obriga as partes e
        seus sucessores, ficando vedada a cessão ou transferência parcial ou
        total dos direitos e obrigações oriundos do presente Instrumento, salvo,
        no caso da Karsten, para as empresas pertencentes ao seu grupo
        econômico.
      </p>

      <p></p>

      <p>
        16.5&ensp;&ensp;&ensp;&ensp;A invalidade, ilegalidade e/ou ineficácia de
        qualquer disposição deste Contrato não prejudicará as demais disposições
        que forem separáveis da disposição defeituosa.
      </p>

      <p></p>

      <p>
        16.6&ensp;&ensp;&ensp;&ensp;A tolerância da Karsten quanto a eventual
        descumprimento de quaisquer das cláusulas ou condições deste instrumento
        e seus Anexos, não será considerada ou interpretada como novação ou
        renúncia, nem afetará os seus direitos, que poderão ser exercidos a
        qualquer tempo.
      </p>

      <p></p>

      <p>
        16.7&ensp;&ensp;&ensp;&ensp;O presente Contrato não estabelece vínculo
        de exclusividade entre as Partes, seja de que natureza for.
      </p>

      <p></p>

      <p>
        16.8&ensp;&ensp;&ensp;&ensp;A Karsten poderá, a qualquer tempo e
        independentemente de prévio aviso, alterar o presente Instrumento, seus
        Anexos e as condições comerciais da Prateleira Infinita, bem como
        encerrar a Plataforma, sem que disso decorra qualquer direito de
        ressarcimento ou indenização pela Empresa Parceira.
      </p>

      <p></p>

      <p>
        16.9&ensp;&ensp;&ensp;&ensp;Nenhuma das partes será responsabilizada
        perante a outra em decorrência de caso fortuito ou evento de força
        maior.
      </p>

      <p></p>

      <p>
        16.10&ensp;&ensp;&ensp;&ensp;Qualquer notificação e comunicação entre as
        partes deverá ser efetuada por escrito, através de carta com aviso de
        recebimento, e-mail ou na Plataforma.
      </p>

      <p></p>

      <p>
        16.11&ensp;&ensp;&ensp;&ensp;Na hipótese de conflito entre o presente
        Contrato e seus anexos, prevalecerá as disposições contidas neste
        instrumento.
      </p>

      <p></p>

      <strong>
        <u>17. CONCORDÂNCIA E ACEITAÇÃO DO CONTRATO</u>
      </strong>

      <p></p>

      <p>
        17.1&ensp;&ensp;&ensp;&ensp;Ao aceitar estas Condições Gerais na
        Plataforma, assim entendido pelo clique no botão de confirmação
        correspondente, o respectivo <i>opt in</i> constituirá o aceite e a
        concordância da Empresa Parceira quanto à estas Condições Gerais e seus
        Anexos, significando, que, o aceitante, legalmente representado por quem
        de direito, para todos os fins e efeitos, leu, compreendeu e concordou
        com todos os termos e condições previstas neste Instrumento, estando
        plenamente ciente de que tais condições e, bem assim, eventuais
        alterações que posteriormente sejam feitas, balizarão todo o seu
        relacionamento com a Karsten suas afiliadas, parceiros e Clientes,
        durante todo o tempo em que permanecer na Plataforma.
      </p>

      <p></p>

      <strong>
        17.2&ensp;&ensp;&ensp;&ensp;De acordo com o ordenamento jurídico
        vigente, a Empresa Parceira admite e concorda com a sua adesão às
        presentes Condições Gerais através de aceite eletrônico, reconhecendo a
        autoria, validade, eficácia, integridade e autenticidade da sua
        aceitação eletrônica.
      </strong>

      <p></p>

      <strong>
        17.3&ensp;&ensp;&ensp;&ensp;Uma cópia destas Condições Gerais e seus
        Anexos, ficará disponível para download pela Empresa Parceira, no
        portal.
      </strong>

      <p></p>

      <strong>
        <u>18. FORO DE ELEIÇÃO E LEGISLAÇÃO APLICÁVEL</u>
      </strong>

      <p></p>

      <p>
        18.1&ensp;&ensp;&ensp;&ensp;As partes elegem o foro da Comarca de
        Blumenau, Estado de Santa Catarina, como sendo bom e competente para
        dirimir dúvidas ou controvérsias decorrentes deste Instrumento, desde já
        renunciando a qualquer outro, por mais privilegiado que seja.
      </p>

      <p style={{ marginBottom: 0 }}>
        18.2.&ensp;&ensp;&ensp;&ensp;O presente instrumento e a relação
        comercial havida entre a Karsten e a Empresa Parceira, interpretar-se-ão
        pela legislação vigente na República Federativa do Brasil.
      </p>

      <br />
    </div>
  );
};
